import { AutoMap } from "@automapper/classes";

export class EndoscopeEntity {

    Id?: number;
    @AutoMap()
    TaskStatus!: number
    @AutoMap()
    Code!: string;
    @AutoMap()
    SamplingDate!: string;
    @AutoMap()
    ZoneSalle!: string;
    @AutoMap()
    Marque!: string;
    @AutoMap()
    Modele!: string;
    @AutoMap()
    NumSerie!: string;
    @AutoMap()
    NumAppareil!: string;

    // ENDOSCOPE SPECIFIC
    @AutoMap()
    TypeEndoscope!: number
    @AutoMap()
    MotifPrelevement!: number
    @AutoMap()
    Traitement!: number
    @AutoMap()
    CycleTraitement!: number
    @AutoMap()
    TypeEauRincage!: number
    @AutoMap()
    DateDernierLavage?: string
    @AutoMap()
    NumeroESET: string = ''
    @AutoMap()
    DateStockageESET?: string
    @AutoMap()
    ConditionPrelevement!: number
    @AutoMap()
    ConditionStockage!: number
    // !ENDOSCOPE SPECIFIC

    CanalIds!: number[];
}